import { links } from "@roman/shared/links";
import { useEffect } from "react";

export const TermsOfService = () => {
  useEffect(() => {
    window.location.href = links.termsOfService;
  }, []);
  return (
    <div className="w-full min-h-screen bg-white">
      別ページに移行しました。
      <a href={links.termsOfService} className="text-secondary underline">
        こちら
      </a>
      からご確認ください。
    </div>
  );
};
